export default __webpack_public_path__ + "static/media/FREQUENT-URINATION.f31422b1.png";